import { ForwardedRef, forwardRef, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { useMergeRefs } from '@xemplo/ref-utils';

import { FieldProps } from '../hooks/hooks.types';
import { useDropdownRhf } from '../hooks/use-dropdown-rhf';
import { TextDropdownRhfProps } from '../types/text-dropdown-rhf.types';

import { TextDropdown } from './text-dropdown';

export const TextDropdownRhf = forwardRef(
  (props: TextDropdownRhfProps, ref?: ForwardedRef<HTMLInputElement>) => {
    const { rules, ...rest } = props;
    const { control } = useFormContext();
    const renderField = useMemo(() => fieldFactory({ ...props }, ref), [props, ref]);

    return (
      <Controller
        name={rest.name}
        rules={rules}
        shouldUnregister={rules?.shouldUnregister}
        control={control}
        render={renderField}
      />
    );
  }
);

/**
 * In order to be able to use react hooks without breaking
 * the rule of hooks, had to extract the render into a component.
 * This is to ensure correctness of the react-hook-form integration.
 **/
const fieldFactory = (
  props: TextDropdownRhfProps,
  ref?: ForwardedRef<HTMLInputElement>
) => {
  return (fieldProps: FieldProps) => {
    const mergedRefs = useMergeRefs([fieldProps.field.ref, ref]);
    const dropdownProps = useDropdownRhf({ ...props, fieldProps });
    return <TextDropdown ref={mergedRefs} {...dropdownProps} />;
  };
};
